<app-navbar [loginDisplay]="loginDisplay"></app-navbar>
<router-outlet *ngIf="!isIframe"></router-outlet>
